import { formatCurrency } from "common/utils/format/number";
import { pluralize } from "common/utils/format/word";

interface TransfersPricingProps {
  unitPrice: number;
  totalPrice: number;
  quantity: number;
}

export function TransfersPricing({ unitPrice, totalPrice, quantity }: TransfersPricingProps) {
  if (quantity <= 0) return null;

  return (
    <div>
      <div className="relative flex items-center">
        {/* Unit price */}
        <span className="text-xl font-semibold text-gray-400">{formatCurrency(unitPrice)}</span>

        {/* Total price - positioned to the right of unit price */}
        <span className="ml-2 text-2xl font-semibold text-gray-800">
          {formatCurrency(totalPrice)} total
        </span>
      </div>

      {/* Quantity text - positioned below and aligned with total price */}
      <div className="flex">
        <div className="w-16" /> {/* Spacer to align with total price */}
        <span className="text-sm font-medium text-gray-900">
          for {pluralize(quantity, "Transfer")}
        </span>
      </div>
    </div>
  );
}
